<template>
    <div class="t-work-area__row">
        <div class="t-work-area__column_big t-profileInfo">
            <div class="t-work-area__cell">
                <cmp-balance :small="true"></cmp-balance>
                <cmp-transactions :small="true"></cmp-transactions>
            </div>

            <cmp-banner></cmp-banner>
            <cmp-courses-table v-if="myCourses.active.items.length" :data="myCourses.active.items" :type="'1'"
                                :title="pageText.title_1"
                                :link="{title: pageText.link_1, url: 'my_courses'}"></cmp-courses-table>
            <cmp-courses-table v-if="entries.active.items.length" :data="entries.active.items" :type="'2'"
                                :title="pageText.title_2"
                                :link="{title: pageText.link_2, url: 'my_entries'}"></cmp-courses-table>
            <cmp-courses-slider v-if="visited.length" :data="visited" :type="'3'"
                                :title="pageText.title_3"></cmp-courses-slider>
            <cmp-promo-courses 
                :text="{title:pageText.title_4}"
                :items="recommendations.courses">
            </cmp-promo-courses>
        </div>
        <cmp-promo-teachers class="t-work-area__column_small"
            :text="{title:pageText.title_5, promoBtn: pageText.promoBtn}"
            :items="recommendations.teachers">
        </cmp-promo-teachers>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/profilePage.json' : 'staticText',
        main: {
            title_1: "Я учу",
            link_1: "Все уроки",
            title_2: "Ваши заявки на урок",
            link_2: "Все заявки",
            title_3: "Недавно просмотренные",
            title_4: "Рекомендуемый курс",
            title_5: "Рекомендуемый учитель",
            title_6: "Вам будет интересно",
            code: "Активировать код",
            promoBtn: 'Заказать рекламу'
        }
    };

    import {store} from '../../store'

    import {mapActions, mapGetters} from 'vuex';

    import Course from '../../vue_components/Course.vue'
    // import Teacher from '../../vue_components/Teacher.vue'
    import Balance from '../../vue_components/Balance.vue'
    import Transactions from '../../vue_components/Transactions.vue'
    import CoursesSlider from '../../vue_components/CoursesSlider.vue'
    import SmallTableCourses from '../../vue_components/Courses/SmallTable.vue'
    import PromoTeachers from '../../vue_components/PromoTeachers.vue'
    import PromoCourses from '../../vue_components/PromoCourses.vue'

    import Banner from '../../vue_components/Banner.vue'

    import ArticlesList from '../../vue_components/ArticlesList.vue'
    import ArticlesSlider from '../../vue_components/ArticlesSlider.vue'

    export default {
        data() {
            return {
                pageText: {},
                offset: 6,
            }
        },
        components: {
            // 'cmp-course': Course,
            // 'cmp-teacher': Teacher,
            'cmp-balance': Balance,
            'cmp-transactions': Transactions,
            'cmp-courses-slider': CoursesSlider,
            'cmp-courses-table': SmallTableCourses,
            'cmp-articles': ArticlesList,
            'cmp-article-slider': ArticlesSlider,
            'cmp-promo-teachers': PromoTeachers,
            'cmp-promo-courses': PromoCourses,
            'cmp-banner': Banner,
        },
        computed: {
            ...mapGetters(['mobileState']),
            ...mapGetters('articles', ['articles']),
            ...mapGetters('recommendations', ['recommendations']),
            ...mapGetters('coursesList', ['myCourses', 'entries', 'visited']),
            ...mapGetters('standartObjects', ['swiperOption']),
            swiperOption_courses_mobile(){
                return this.swiperOption('.js-pagination_courses')
            },
            // swiperOption_teachers_mobile(){ 
            //     return this.swiperOption('.js-pagination__teachers')
            // },
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            // ...mapGetters('standartObjects', ['swiperOption']),
            ...mapActions('articles', ['LoadPersonalArticles']),
            Load(pageText) {
                this.pageText = pageText;
                // setTimeout(() => {
                //     this.UpdatePreloadState(false);
                // }, 500)
            }
        },
        beforeRouteLeave(to, from, next) {
            // this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate(to, from, next) {
            this.LoadPersonalArticles({clear: false, query: {limit: 6, offset: to.query.articles - 6}}).then(() => {
                next();
            });
        },
        beforeRouteEnter(to, from, next) {
            let count = 0;

            let pageText = {};

            let limit = to.query.articles || 6;

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;
                count++;
                RunNext();
            });

            store.dispatch('staticText/LoadBalanceText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('staticText/LoadTransactionsText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadMyCourses').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadEntries').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadMyVisited').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('profile/LoadBalance').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('profile/LoadTransactions', {limit: 3}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadCurrencyList').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('recommendations/LoadRecommendations').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('articles/LoadPersonalArticles', {
                clear: true,
                query: {limit: limit, offset: 0}
            }).then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if (count > 10) {
                    next(vm => vm.Load(pageText))
                }
            }
        }
    }
</script>

<style lang="sass">
    .t-work-area__cell_promo
        .t-courseItem
            margin: 0!important
    .t-profileInfo
        .t-work-area__cell
            margin-bottom: 32px
        .t-courses
            margin-bottom: 19px
            .t-courseItem
                margin: 0!important
            @media (max-width: 769px)
                &__header
                    padding: 0
                    background: transparent
                    
        &__articles
            display: flex
            flex-direction: column
            align-items: center
            h2
                width: 100%
                color: $blue
                margin: 0 0 24px
                padding: 21px 24px
                background: #ffffff
                border-radius: 16px
            .t-btn
                margin: 0 auto
                width: 272px
</style>


// WEBPACK FOOTER //
// src/vue_pages/Profile/Profile.vue